@if (sameHeightElements) {
  <div [formGroup]="formGroup" class="single-col-container" [ngClass]="{ 'children-same-height': !atLeastOneOther }">
    @for (answer of answers; track answer; let i = $index) {
      <label
        (click)="validate(); focusOther(answer.val)"
        class="wrapper"
        [ngClass]="{ picked: formGroup.controls[answer.val].value }"
      >
        <mat-checkbox class="checkbox d-block" [formControl]="formGroup.controls[answer.val] | formControl">
          @if (!withInnerHTML) {
            <span class="wide-span" [ngStyle]="{ textAlign: align }">{{ answer.text }}</span>
          }
          @if (withInnerHTML) {
            <span class="wide-span" [ngStyle]="{ textAlign: align }" [innerHTML]="answer.text"></span>
          }
        </mat-checkbox>
        @if (answer.tooltip && answer.tooltip !== '') {
          <div
            #tooltip="matTooltip"
            (click)="tooltip.toggle(); $event.preventDefault()"
            [matTooltip]="answer.tooltip"
            class="info-icon"
            inlineSVG="/icons/icon-info.svg"
          ></div>
        }
        @if (formGroup.controls[answer.val].value && answer.is_other) {
          <div class="other-container">
            <mat-form-field class="form-field form-field-search" [floatLabel]="'auto'">
              <mat-label [innerHTML]="answer.text"></mat-label>
              <input
                #otherInput
                [id]="'other' + answer.val"
                [ngStyle]="{ textAlign: align }"
                [formControl]="othersFg.controls[answer.val] | formControl"
                matInput
                type="text"
              />
            </mat-form-field>
          </div>
        }
      </label>
    }
  </div>
}
@if (!sameHeightElements) {
  <div [formGroup]="formGroup" class="layout" [ngClass]="{ multi: multipleCols }">
    @for (answer of answers; track answer) {
      <label
        (click)="validate(); focusOther(answer.val)"
        class="wrapper"
        [ngClass]="{ picked: formGroup.controls[answer.val].value }"
      >
        <mat-checkbox class="checkbox d-block" [formControl]="formGroup.controls[answer.val] | formControl">
          @if (!withInnerHTML) {
            <span>{{ answer.text }}</span>
          }
          @if (withInnerHTML) {
            <span [innerHTML]="answer.text"></span>
          }
        </mat-checkbox>
        @if (answer.tooltip && answer.tooltip !== '') {
          <div
            #tooltip="matTooltip"
            (click)="tooltip.toggle(); $event.preventDefault()"
            [matTooltip]="answer.tooltip"
            class="info-icon"
            inlineSVG="/icons/icon-info.svg"
          ></div>
        }
        @if (formGroup.controls[answer.val].value && answer.is_other) {
          <div class="other-container">
            <mat-form-field class="form-field form-field-search" [floatLabel]="'auto'">
              <mat-label [innerHTML]="answer.text"></mat-label>
              <input
                #otherInput
                [id]="'other' + answer.val"
                [ngStyle]="{ textAlign: align }"
                [formControl]="othersFg.controls[answer.val] | formControl"
                matInput
                type="text"
              />
            </mat-form-field>
          </div>
        }
      </label>
    }
  </div>
}
@if (formGroup.touched && getFirstControlWithError('min', formGroup); as control) {
  <mat-error>
    {{ control.errors?.message }}
  </mat-error>
}
@if (formGroup.touched && getFirstControlWithError('max', formGroup); as control) {
  <mat-error>
    {{ control.errors?.message }}
  </mat-error>
}
